import { render, staticRenderFns } from "./checkbox.component.vue?vue&type=template&id=df512b38&scoped=true"
import script from "./checkbox.component.vue?vue&type=script&lang=js"
export * from "./checkbox.component.vue?vue&type=script&lang=js"
import style0 from "./checkbox.component.vue?vue&type=style&index=0&id=df512b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df512b38",
  null
  
)

export default component.exports